// Singleton loader for Google Maps JavaScript API + Places library.
// Reuses one <script> across the app and resolves to `window.google`.
let loadingPromise = null;

export function loadGoogleMaps() {
  if (typeof window === "undefined") return Promise.reject(new Error("no window"));
  if (window.google && window.google.maps && window.google.maps.places) {
    return Promise.resolve(window.google);
  }
  if (loadingPromise) return loadingPromise;

  const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!key) return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY missing"));

  loadingPromise = new Promise((resolve, reject) => {
    const cb = `__gmaps_cb_${Date.now()}`;
    window[cb] = () => {
      try {
        resolve(window.google);
      } finally {
        try { delete window[cb]; } catch { /* noop */ }
      }
    };
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(key)}&libraries=places,geometry&loading=async&callback=${cb}`;
    s.async = true;
    s.defer = true;
    s.onerror = () => reject(new Error("Failed to load Google Maps"));
    document.head.appendChild(s);
  });

  return loadingPromise;
}
